import { useState } from 'react';
import Button from '../../components/common/Button';
import { UserDrawer } from '../../components/modals';
import './Users.css';

const MOCK_USERS = [
  { id: 1, name: 'John Chen', email: 'john@l100.ai', tenant: 'L100.ai', role: 'Admin', status: 'active', lastLogin: '2 min ago' },
  { id: 2, name: 'Sarah Miller', email: 'sarah@supersearch.ai', tenant: 'SuperSearch.ai', role: 'User', status: 'active', lastLogin: '15 min ago' },
  { id: 3, name: 'Alex Johnson', email: 'alex@mirror1.ai', tenant: 'Mirror1.ai', role: 'Admin', status: 'active', lastLogin: '1 hour ago' },
  { id: 4, name: 'Emily Davis', email: 'emily@cachee.io', tenant: 'Cachee', role: 'User', status: 'suspended', lastLogin: '2 days ago' },
  { id: 5, name: 'Michael Brown', email: 'michael@babykong.ai', tenant: 'BabyKong.ai', role: 'Owner', status: 'active', lastLogin: '5 min ago' },
];

const Users = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedUserEmail, setSelectedUserEmail] = useState(null);
  const [isUserDrawerOpen, setIsUserDrawerOpen] = useState(false);

  const handleViewUser = (email) => {
    setSelectedUserEmail(email);
    setIsUserDrawerOpen(true);
  };

  const filteredUsers = MOCK_USERS.filter(user =>
    user.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    user.email.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="users-page">
      <div className="page-header">
        <div>
          <h1 className="page-title">Users</h1>
          <p className="page-subtitle">Manage users across all tenants</p>
        </div>
        <div className="page-actions">
          <Button variant="secondary" icon="refresh">Sync</Button>
          <Button variant="primary" icon="plus">Add User</Button>
        </div>
      </div>

      <div className="users-toolbar">
        <div className="search-box">
          <span className="icon"><svg><use href="#icon-search"></use></svg></span>
          <input
            type="text"
            placeholder="Search users..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
        <div className="filter-group">
          <select className="filter-select">
            <option value="">All Status</option>
            <option value="active">Active</option>
            <option value="suspended">Suspended</option>
          </select>
          <select className="filter-select">
            <option value="">All Roles</option>
            <option value="owner">Owner</option>
            <option value="admin">Admin</option>
            <option value="user">User</option>
          </select>
        </div>
      </div>

      <div className="users-table-container">
        <table className="users-table">
          <thead>
            <tr>
              <th>User</th>
              <th>Tenant</th>
              <th>Role</th>
              <th>Status</th>
              <th>Last Login</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredUsers.map(user => (
              <tr key={user.id}>
                <td>
                  <div className="user-cell">
                    <div className="user-avatar-sm">
                      {user.name.split(' ').map(n => n[0]).join('')}
                    </div>
                    <div className="user-info">
                      <div className="user-name">{user.name}</div>
                      <div className="user-email">{user.email}</div>
                    </div>
                  </div>
                </td>
                <td>{user.tenant}</td>
                <td>
                  <span className={`role-badge role-${user.role.toLowerCase()}`}>
                    {user.role}
                  </span>
                </td>
                <td>
                  <span className={`status-badge status-${user.status}`}>
                    {user.status}
                  </span>
                </td>
                <td className="text-tertiary">{user.lastLogin}</td>
                <td>
                  <div className="action-buttons">
                    <Button variant="ghost" size="xs" icon="eye" iconOnly aria-label="View user" onClick={() => handleViewUser(user.email)} />
                    <Button variant="ghost" size="xs" icon="edit" iconOnly aria-label="Edit user" />
                    <Button variant="ghost" size="xs" icon="lock" iconOnly aria-label="User security" />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <UserDrawer
        isOpen={isUserDrawerOpen}
        onClose={() => setIsUserDrawerOpen(false)}
        userEmail={selectedUserEmail}
      />
    </div>
  );
};

export default Users;
